import { Operator } from '@jexop/core';
import { isDate, isString } from 'lodash';
import { DateTime } from 'luxon';
import { Nullable } from '../types';

export const formatDate: Operator<string> = ({ value, format }): Nullable<string> => {
  if (!isString(value) && !isDate(value)) {
    return null;
  }
  const date = isString(value) ? DateTime.fromISO(value) : DateTime.fromJSDate(value);

  if (!date.isValid) {
    return null;
  }

  switch (format) {
    case 'short': return date.toLocaleString(DateTime.DATE_SHORT);
    case 'long': return date.toLocaleString(DateTime.DATE_FULL);
    default: return date.toLocaleString(DateTime.DATE_MED);
  }
};
